import React, { Fragment, useEffect, useRef, useContext } from "react";
import { ChevronDownIcon } from "@heroicons/react/solid";
import { Menu, Transition } from "@headlessui/react";
import "./ChatRow.css";
import axios from "axios";
import {
  DocumentIcon,
  PhotographIcon,
  VideoCameraIcon,
  CodeIcon,
  MicrophoneIcon,
} from "@heroicons/react/solid";
import TimeAgo from "timeago-react";
import en from "javascript-time-ago/locale/en.json";
import { ShimmerCategoryItem } from "react-shimmer-effects";
import backendService from "../services.js/backendService";
import "react-toastify/dist/ReactToastify.css";
import { socket, SocketContext } from "../services.js/socket";
import { io } from "socket.io-client";
import useState from "react-usestateref";
import FlipMove from "react-flip-move";
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from "react-query";
import ReactTooltip from "react-tooltip";
import { useNavigate } from "react-router-dom";

const optimizeURL = (URL) => {
  const parametre = "upload/q_auto:best";
  return URL.replace("upload", parametre);
};
function QuipComponent() {
  return Array.apply(null, { length: 5 }).map((e, i) => (
    <ShimmerCategoryItem
      key={i}
      hasImage
      imageType="circular"
      imageWidth={56}
      imageHeight={56}
      contentCenter
      text
    />
  ));
}

async function handleRecents() {
  try {
    const response = await axios.get(`${process.env.REACT_APP_URL}/getconversations`, {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": backendService.getToken(),
      },
    });
    return response.data.conversations;
  } catch (error) {
    return error.response;
  }
}

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function ChatRow(props) {
  const [chevronIcon, setChevronIcon] = useState(false);
  const queryClient = useQueryClient();
  const convoRef = useRef();
  const navigate = useNavigate();
  const socket = useContext(SocketContext);
  const { data, status, refetch } = useQuery("recents", handleRecents, {
    retry: true,
  });
  const [selected, setSelected, selectedRef] = useState(
    props.currentOpenedConvo
  );

  const [recents, setRecents] = useState([]);
  const [conversations, setConversations] = useState([]);
  useEffect(() => {
    if (data) {
      data.map((convo) => {
        if (convo.participants[0]._id === selectedRef.current) {
          props.getCurrent(convo);
        }
      });
    }
  }, [selected]);

  useEffect(() => {
    socket.on("recentsUpdate", (data) => {
      refetch();
      
    });
  }, []);
  useEffect(() => {
    if (data?.length > 0) {
      setRecents(data);
      setConversations(
        data?.filter((conversation) => conversation?.lastMessage?.length > 0)
      );
      props.getContacts(data);
    }
  }, [data]);
  useEffect(() => {
    refetch();
  }, [props.clicked]);
  useEffect(() => {
    setSelected(props.currentOpenedConvo);
  }, [props.currentOpenedConvo]);
  useEffect(() => {
    if (props.searchText.length > 0) {
      //update setRecents to filter by searchText
      setRecents(
        recents.filter((item) =>
          item.participants[0].firstname
            .toLowerCase()
            .includes(props.searchText.toLowerCase())
        )
      );
    } else {
      setRecents(data);
    }
  }, [props.searchText]);
  function truncate(string, n) {
    return string?.length > n ? string.substr(0, n - 1) + "..." : string;
  }
  if (status === "loading") {
    return <div className="pl-4"> <QuipComponent /></div>;
  }
  if (status === "error") {
    return <p>There was an error</p>;
  }

  return (
    <div className=" h-screen w-full overflow-y-auto scrollbar-track-pallete_color3 overflow-x-hidden scroll-smooth chat__container bg-palette_color2">
      <ReactTooltip delayShow={500} delayHide={100} />
      {props.searchText.length > 0 ? (
        recents.length > 0 ? (
          recents.map((chatData, index) => (
            <div
              key={chatData.participants[0]._id}
              onClick={() => {
                setSelected(chatData.participants[0]._id);
                props.getCurrentOpenedConvo(chatData.participants[0]._id);
                props.getCurrent(chatData);
                navigate(`/home/inbox/${chatData.participants[0]._id}`);
                refetch();
              }}
              onLoad={() => {
                if (selectedRef.current === chatData.participants[0]._id) {
                  props.getCurrent(chatData);
                }
              }}
              className={classNames(
                selectedRef.current === chatData.participants[0]._id
                  ? " text-white bg-palette_color1"
                  : "",
                "flex cursor-pointer   h-[65px] shadow  rounded-lg hover:bg-[#254441]  hover:text-white border-secondary m-3 transition-all duration-500 ease-in-out"
              )}
              onMouseEnter={() => setChevronIcon(true)}
              onMouseLeave={() => setChevronIcon(false)}
            >
              <div className="flex flex-none items-center px-3 sm:px-4 justify-center ">
                <div className="">
                  <img
                    alt="Profile"
                    className="rounded-full h-[40px] w-[40px] cursor-pointer"
                    src={
                      chatData.participants[0].profilePicture
                        ? optimizeURL(
                            chatData.participants[0].profilePicture.filePath
                          )
                        : require("../assets/boredApe.png")
                    }
                  />
                </div>
              </div>
              <div className="flex flex-grow min-w-0 items-center px-2 sm:px-3 ">
                <div className="w-full ">
                  <div className="justify-center items-center pb-1">
                    <div className="flex justify-between items-center mr-2">
                      <h3 className=" text-md font-robo   ">
                        {String(chatData.participants[0].firstname)
                          .charAt(0)
                          .toUpperCase() +
                          String(chatData.participants[0].firstname).slice(1)}
                      </h3>
                      {chatData.lastUpdated && (
                        <h3 className=" text-xs antialiased font-robo">
                          <TimeAgo datetime={chatData.lastUpdated} />
                        </h3>
                      )}
                    </div>
                    <div className="flex justify-between items-center -mt-1 ">
                      {chatData?.lastMessageType === "text" ? (
                        <p className=" font-robo text-xs opacity-70 ">
                          {truncate(chatData.lastMessage, 25)}
                        </p>
                      ) : chatData?.lastMessageType === "file" ? (
                        <div className="flex justify-between items-center opacity-70">
                          <DocumentIcon className="h-4 w-4   right-0 cursor-pointer" />
                          <p className=" text-xs font-robo ">File</p>
                        </div>
                      ) : chatData?.lastMessageType === "image" ? (
                        <div className="flex justify-between items-center opacity-70">
                          <PhotographIcon className="h-4 w-4   right-0 cursor-pointer" />
                          <p className=" text-xs font-robo ">Image</p>
                        </div>
                      ) : chatData?.lastMessageType === "video" ? (
                        <div className="flex justify-between items-center opacity-70">
                          <VideoCameraIcon className="h-4 w-4   right-0 cursor-pointer" />
                          <p className=" text-xs font-robo ">Video</p>
                        </div>
                      ) : chatData?.lastMessageType === "audio" ? (
                        <div className="flex justify-between items-center opacity-70">
                          <MicrophoneIcon className="h-4 w-4   right-0 cursor-pointer" />
                          <p className=" text-xs font-robo ">Audio</p>
                        </div>
                      ) : chatData.lastMessage &&
                        chatData?.lastMessageType?.includes("code") ? (
                        <div className="flex justify-between items-center opacity-70">
                          <CodeIcon className="h-4 w-4   right-0 cursor-pointer" />
                          <p className=" text-xs font-robo ">
                            {truncate(chatData.lastMessage, 10)}
                          </p>
                        </div>
                      ) : (
                        <p className=" text-xs"></p>
                      )}

                      {selectedRef.current !== chatData.participants[0]._id &&
                      chatData.unread[0]?.count &&
                      chatData.unread[0].count !== 0 &&
                      chatData?.lastSender !==
                        backendService.getLoggedInUser()["_id"] ? (
                        <div
                          className=" h-2 w-2  border-white rounded-full bg-[#44ff00]  mr-4"
                          data-tip="Unread Messages"
                          data-place="left"
                        ></div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="flex justify-center items-center">
            <p className="text-primary text-xl font-robo font-semibold  mt-10">
              No Search Result
            </p>
          </div>
        )
      ) : data.length > 0 ? (
        conversations.map((chatData, index) => (
          <div
            key={chatData.participants[0]._id}
            onClick={() => {
              setSelected(chatData.participants[0]._id);
              props.getCurrentOpenedConvo(chatData.participants[0]._id);
              props.getCurrent(chatData);
              navigate(`/home/inbox/${chatData.participants[0]._id}`);
              refetch();
            }}
            onLoad={() => {
              if (selectedRef.current === chatData.participants[0]._id) {
                props.getCurrent(chatData);
              }
            }}
            className={classNames(
              selectedRef.current === chatData.participants[0]._id
                ? " text-white bg-palette_color1 focus:outline-none"
                : "",
              "flex cursor-pointer   h-[65px] shadow  rounded-lg hover:bg-[#254441]  hover:text-white border-secondary m-3 transition-all duration-500 ease-in-out"
            )}
          >
            <div className="flex flex-none items-center px-3 sm:px-4 justify-center ">
              <div className="">
                <img
                  alt="Profile"
                  className="rounded-full h-[40px] w-[40px] cursor-pointer"
                  src={
                    chatData.participants[0].profilePicture
                      ? optimizeURL(
                          chatData.participants[0].profilePicture.filePath
                        )
                      : require("../assets/boredApe.png")
                  }
                />
              </div>
            </div>
              <div className="flex flex-grow min-w-0 items-center px-2 sm:px-3 ">
              <div className="w-full ">
                <div className="justify-center items-center pb-1">
                  <div className="flex justify-between items-center mr-2">
                    <h3 className=" text-md font-robo   ">
                      {String(chatData.participants[0].firstname)
                        .charAt(0)
                        .toUpperCase() +
                        String(chatData.participants[0].firstname).slice(1)}
                    </h3>
                    {chatData.lastUpdated && (
                      <h3 className=" text-xs antialiased font-robo">
                        <TimeAgo datetime={chatData.lastUpdated} />
                      </h3>
                    )}
                  </div>
                  <div className="flex justify-between items-center -mt-1 ">
                    {chatData?.lastMessageType === "text" ? (
                      <p className=" font-robo text-xs opacity-70 ">
                        {truncate(chatData.lastMessage, 25)}
                      </p>
                    ) : chatData?.lastMessageType === "file" ? (
                      <div className="flex justify-between items-center opacity-70">
                        <DocumentIcon className="h-4 w-4   right-0 cursor-pointer" />
                        <p className=" text-xs font-robo ">File</p>
                      </div>
                    ) : chatData?.lastMessageType === "image" ? (
                      <div className="flex justify-between items-center opacity-70">
                        <PhotographIcon className="h-4 w-4   right-0 cursor-pointer" />
                        <p className=" text-xs font-robo ">Image</p>
                      </div>
                    ) : chatData?.lastMessageType === "video" ? (
                      <div className="flex justify-between items-center opacity-70">
                        <VideoCameraIcon className="h-4 w-4   right-0 cursor-pointer" />
                        <p className=" text-xs font-robo ">Video</p>
                      </div>
                    ) : chatData?.lastMessageType === "audio" ? (
                      <div className="flex justify-between items-center opacity-70">
                        <MicrophoneIcon className="h-4 w-4   right-0 cursor-pointer" />
                        <p className=" text-xs font-robo ">Audio</p>
                      </div>
                    ) : chatData.lastMessage &&
                      chatData?.lastMessageType?.includes("code") ? (
                      <div className="flex justify-between items-center opacity-70">
                        <CodeIcon className="h-4 w-4   right-0 cursor-pointer" />
                        <p className=" text-xs font-robo ">
                          {truncate(chatData.lastMessage, 10)}
                        </p>
                      </div>
                    ) : (
                      <p className=" text-xs"></p>
                    )}

                    {selectedRef.current !== chatData.participants[0]._id &&
                    chatData.unread[0]?.count &&
                    chatData.unread[0].count !== 0 &&
                    chatData?.lastSender !==
                      backendService.getLoggedInUser()["_id"] ? (
                      <div
                        className=" h-2 w-2  border-white rounded-full bg-[#44ff00]  mr-4"
                        data-tip="Unread Messages"
                        data-place="left"
                      ></div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="flex flex-col justify-center items-center">
          <p className="text-primary text-xl font-robo  mt-10">
            No Conversations yet
          </p>
          {/* <button
            className=" bg-palette_color1 my-3 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-6 py-3 rounded shadow-sm hover:border hover:border-palette_color1 hover:shadow-lg  mr-1 mb-1 ease-linear transition-all duration-500"
            type="button"
            onClick={async () => props.openSearchUser(true)}
          >
            Add Friends
          </button> */}
        </div>
      )}
    </div>
  );
}

export default ChatRow;
